import { isTour } from "lib/predicates";
import { DescriptionSection } from "./DescriptionSection";
import { DetailSection } from "./DetailSection";
import { DirectionsSection } from "./DirectionsSection";
import { FeatureSection } from "./FeatureSection";
import { ImageSection } from "./ImageSection";
import { InformationSection } from "./InformationSection";
import { MapSection } from "./MapSection";
import { TourDetailSection } from "./TourDetailSection";

export const Section = ({
  item,
  section,
  full,
}: {
  item: Travelguide.OOI;
  section: Travelguide.OOISection;
  full?: boolean;
}) => {
  switch (section.type) {
    case "description":
      return <DescriptionSection item={item} section={section} full={full} />;
    case "image":
      return <ImageSection section={section} />;
    case "detail":
      return isTour(item) ? (
        <TourDetailSection item={item} section={section} />
      ) : (
        <DetailSection section={section} />
      );
    case "information":
      return <InformationSection section={section} />;
    case "directions":
      return <DirectionsSection item={item} section={section} />;
    case "map":
      return <MapSection item={item} section={section} />;
    case "feature":
      return <FeatureSection section={section} />;
  }
};
